export const SET_CURRENT_CUSTOMER_DETAILS = 'SET_CURRENT_CUSTOMER_DETAILS';
export const RESET_CURRENT_CUSTOMER_DETAILS = 'RESET_CURRENT_CUSTOMER_DETAILS';
export const SET_CURRENT_CUSTOMER_DETAILS_STATUSES = 'SET_CURRENT_CUSTOMER_DETAILS_STATUS';

export const SET_PRODUCTS_DETAILS = 'SET_PRODUCTS_DETAILS';
export const SET_CURRENT_PRODUCT_ACCOUNT = 'SET_CURRENT_PRODUCT_ACCOUNT';
export const RESET_CURRENT_PRODUCT_ACCOUNT = 'RESET_CURRENT_PRODUCT_ACCOUNT';
export const SET_CURRENT_PRODUCT_ACCOUNT_ECHANNELS = 'SET_CURRENT_PRODUCT_ACCOUNT_ECHANNELS';
export const SET_CURRENT_PRODUCT_ACCOUNT_STATUSES = 'SET_CURRENT_PRODUCT_ACCOUNT_STATUSES';
export const SET_CURRENT_PRODUCT_ECHANNEL = 'SET_CURRENT_PRODUCT_ECHANNEL';
export const SET_CURRENT_PRODUCT_ECHANNEL_STATUSES = 'SET_CURRENT_PRODUCT_ECHANNEL_STATUSES';
export const SET_CURRENT_PRODUCT_GLS_CASH_CON = 'SET_CURRENT_PRODUCT_GLS_CASH_CON';
export const SET_CURRENT_PRODUCT_GLS_CASH_CON_STATUSES = 'SET_CURRENT_PRODUCT_GLS_CASH_CON_STATUSES';
export const SET_CORSS_BORDER_STATUS = 'SET_CORSS_BORDER_STATUS';

export const SET_ACTIVATION_TAB_DATA = 'SET_ACTIVATION_TAB_DATA';

export const SET_CURRENT_ACTIVE_TAB = 'SET_CURRENT_ACTIVE_TAB';
export const SET_TABS_STATUS = 'SET_TABS_STATUS';
export const SET_TABS_STATUSES = 'SET_TABS_STATUSES';
export const ENABLE_TAB = 'ENABLE_TAB';
export const ENABLE_TABS = 'ENABLE_TABS';
export const DISABLE_TAB = 'DISABLE_TAB';
export const DISABLE_TABS = 'DISABLE_TABS';

export const SET_ADDRESSES = 'SET_ADDRESSES';
export const SET_PERSONS = 'SET_PERSONS';
export const SET_CASE_OWNER = 'SET_CASE_OWNER';

export const ENABLE_CASE_BODY_FOOTER_BTN = 'ENABLE_CASE_BODY_FOOTER_BTN';
export const DISABLE_CASE_BODY_FOOTER_BTN = 'DISABLE_CASE_BODY_FOOTER_BTN';
export const ENABLE_ALL_CASE_BODY_FOOTER_BTNS = 'ENABLE_ALL_CASE_BODY_FOOTER_BTNS';
export const DISABLE_ALL_CASE_BODY_FOOTER_BTNS = 'DISABLE_ALL_CASE_BODY_FOOTER_BTNS';
export const HIDE_PREVIEW_AND_GENERATEDOC_BTNS = 'HIDE_PREVIEW_AND_GENERATEDOC_BTNS';
export const SHOW_PREVIEW_AND_GENERATEDOC_BTNS = 'SHOW_PREVIEW_AND_GENERATEDOC_BTNS';
export const ENABLE_CASE_BODY_FOOTER_SUBMIT_BTN = 'ENABLE_CASE_BODY_FOOT ER_SUBMIT_BTN';
export const NEW_ENTITIES = 'NEW_ENTITIES';
export const OLD_ENTITIES = 'OLD_ENTITIES';
export const SET_CUSTOMER_DETAIL_ACTIVE_TAB_INDEX = 'SET_CUSTOMER_DETAIL_ACTIVE_TAB_INDEX';
export const RESET_CUSTOMER_DETAIL_ACTIVE_TAB_INDEX = 'RESET_CUSTOMER_DETAIL_ACTIVE_TAB_INDEX';

export const SET_NEW_ACCOUNT_ACTIVE_TAB_INDEX = 'SET_NEW_ACCOUNT_ACTIVE_TAB_INDEX';
export const RESET_NEW_ACCOUNT_ACTIVE_TAB_INDEX = 'RESET_NEW_ACCOUNT_ACTIVE_TAB_INDEX';

export const SET_E_CHANNEL_ACTIVE_TAB_INDEX = 'SET_E_CHANNEL_ACTIVE_TAB_INDEX';
export const RESET_E_CHANNEL_ACTIVE_TAB_INDEX = 'RESET_E_CHANNEL_ACTIVE_TAB_INDEX';

export const SET_COUNTRY_FORM_TAB_INDEX = 'SET_COUNTRY_FORM_TAB_INDEX';
export const RESET_COUNTRY_FORM_TAB_INDEX = 'RESET_COUNTRY_FORM_TAB_INDEX';
export const SET_LANDING_ACTIVE_TAB = 'SET_LANDING_ACTIVE_TAB'
export const SET_DARK_FLAG = 'SET_DARK_FLAG'
export const SET_SOW_NEW_SWEEP_ACTIVE_TAB_INDEX = 'SET_SOW_NEW_SWEEP_ACTIVE_TAB_INDEX';
export const RESET_NEW_SWEEP_ACTIVE_TAB_INDEX = 'RESET_NEW_SWEEP_ACTIVE_TAB_INDEX';
export const SET_NEW_SWEEP_ACTIVE_TAB_INDEX = 'SET_NEW_SWEEP_ACTIVE_TAB_INDEX';

export const SET_GENERATE_DOC = 'SET_GENERATE_DOC';
export const SET_GLS_AGENT = 'SET_GLS_AGENT';

export const SET_CURRENT_PRODUCT_ACH = 'SET_CURRENT_PRODUCT_ACH';
export const SET_OTHER_ACCOUNT_ACH = 'SET_OTHER_ACCOUNT_ACH';
export const RESET_CURRENT_ACH_PRODUCT = 'RESET_CURRENT_ACH_PRODUCT';
export const SET_ACH_CREDIT_ACTIVE_TAB_INDEX = 'SET_ACH_CREDIT_ACTIVE_TAB_INDEX';
export const RESET_ACH_CREDIT_ACTIVE_TAB_INDEX = 'RESET_ACH_CREDIT_ACTIVE_TAB_INDEX';

export const SET_CURRENT_PRODUCT_ACCOUNTS = 'SET_CURRENT_PRODUCT_ACCOUNTS';
export const SET_EXISTING_ENTITY_DATA = 'SET_EXISTING_ENTITY_DATA';
export const RESET_CORPORATECARD_PRODUCT = 'RESET_CORPORATECARD_PRODUCT';
export const SET_PRODUCT_CORPORATECARD = 'SET_PRODUCT_CORPORATECARD';
export const SET_CORPORATECARD_ACTIVE_TAB_INDEX = 'SET_CORPORATECARD_ACTIVE_TAB_INDEX';
export const RESET_CORPORATECARD_ACTIVE_TAB_INDEX = 'RESET_CORPORATECARD_ACTIVE_TAB_INDEX';
export const RESET_CASHFLOWFORECASTING_PRODUCT = 'RESET_CASHFLOWFORECASTING_PRODUCT';
export const SET_PRODUCT_CASHFLOWFORECASTING = 'SET_PRODUCT_CASHFLOWFORECASTING';
export const SET_CASHFLOWFORECASTING_ACTIVE_TAB_INDEX = 'SET_CASHFLOWFORECASTING_ACTIVE_TAB_INDEX';
export const RESET_CASHFLOWFORECASTING_ACTIVE_TAB_INDEX = "RESET_CASHFLOWFORECASTING_ACTIVE_TAB_INDEX";
export const SET_CURRENT_DROPDOWNSELECT = 'SET_CURRENT_DROPDOWNSELECT';
export const RESET_CURRENT_DROPDOWNSELECT = 'RESET_CURRENT_DROPDOWNSELECT';
export const SET_SOW_BODY_CUSTOMER_ACTIVE_TAB_INDEX = 'SET_SOW_BODY_CUSTOMER_ACTIVE_TAB_INDEX'
export const RESET_SOW_BODY_CUSTOMER_ACTIVE_TAB_INDEX = 'RESET_SOW_BODY_CUSTOMER_ACTIVE_TAB_INDEX'

export const SAVE_DATA_NOTIONAL_POOLING = 'SAVE_DATA_NOTIONAL_POOLING'
export const NOTIONAL_POOLING_DELETEPOOL = 'NOTIONAL_POOLING_DELETEPOOL'
export const SET_CURRENT_NOTIONAL_POOLING_STATUSES = 'SET_CURRENT_NOTIONAL_POOLING_STATUSES'
export const SET_CURRENT_NOTIONAL_POOLING_PARTY_CURRENCY = 'SET_CURRENT_NOTIONAL_POOLING_PARTY_CURRENCY'
export const SET_CURRENT_NOTIONAL_POOLING_BD_ACCOUNTS = 'SET_CURRENT_NOTIONAL_POOLING_BD_ACCOUNTS'
export const SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON = 'SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON'
export const SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_ACCODRIAN = 'SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_ACCODRIAN'
export const SET_CURRENT_NOTIONAL_POOLING_INTEREST_OPTIMIZATION_DATA = 'SET_CURRENT_NOTIONAL_POOLING_INTEREST_OPTIMIZATION_DATA'
export const SET_CURRENT_NOTIONAL_POOLING_INTEREST_PERIOD_SETTLEMENT_DATE = 'SET_CURRENT_NOTIONAL_POOLING_INTEREST_PERIOD_SETTLEMENT_DATE'
export const UPDATE_ACCOUNT_INFO = 'UPDATE_ACCOUNT_INFO'
export const SET_STATND_ALONE_ACCOUNTS = 'SET_STATND_ALONE_ACCOUNTS'
export const SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_1 = 'SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_1'
export const SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_2 = 'SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_2'
export const SET_CURRENT_NOTIONAL_POOLING_POOL_ID = 'SET_CURRENT_NOTIONAL_POOLING_POOL_ID'
export const RESET_CURRENT_NOTIONAL_POOLING_POOL_ID = 'RESET_CURRENT_NOTIONAL_POOLING_POOL_ID'
export const SET_NEW_POOL_ACTIVE_TAB_INDEX = 'SET_NEW_POOL_ACTIVE_TAB_INDEX';
export const RESET_NEW_POOL_ACTIVE_TAB_INDEX = 'RESET_NEW_POOL_ACTIVE_TAB_INDEX';



// WEBPACK FOOTER //
// ./src/components/SowBody/actions/actionTypes.js